<button
  class="button"
  [ngClass]="'button-' + buttonStyle"
  [class.is-disabled]="isDisabled"
  (click)="handleClick()"
>
  <ng-content></ng-content>
</button>
